"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionAddAndUpdateActionWatcher = exports.transactionChangeActionWatcher = exports.createPayeeListActionWatcher = exports.updatePayeeListActionWatcher = exports.triggerPayeeListUpdate = exports.updatePayeeList = exports.createPayeeList = exports.buildPayeeList = void 0;
const effects_1 = require("redux-saga/effects");
const immutable_1 = require("immutable");
const uuid_1 = require("uuid");
const luxon_1 = require("luxon");
const accounts_1 = require("companion-app-components/flux/accounts");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const transactions_1 = require("companion-app-components/flux/transactions");
const selectors_1 = require("data/transactions/selectors");
const searchFilter_1 = require("data/transactions/searchFilter");
const selectors_2 = require("data/preferences/selectors");
const types_1 = require("./types");
const actions = __importStar(require("./actions"));
const utils_1 = require("./utils");
function buildPayeeList(accountsById, transactionsByAccountId, resources) {
    let changedAccounts;
    if (resources) {
        changedAccounts = resources.map((x) => x.accountId);
        changedAccounts = changedAccounts.filter((item, pos) => changedAccounts.indexOf(item) === pos);
    }
    else {
        changedAccounts = accountsById.map((x) => x.id);
    }
    let payeeListById = (0, immutable_1.Map)();
    // now for each account changed, rebuild the payee list
    changedAccounts.forEach((accountId) => {
        const acct = accountsById.get(accountId);
        if (acct && acct.type !== 'LOAN') {
            let payeeList = (0, immutable_1.Map)();
            const txns = transactionsByAccountId.get(accountId);
            if (txns) {
                txns.forEach((txn) => {
                    var _a, _b, _c;
                    if (!txn.isDeleted && (((_a = txn.payee) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0) {
                        const payeeObject = {
                            id: (0, uuid_1.v4)(),
                            name: txn.payee,
                            amountString: (0, searchFilter_1.getFieldString)('amount', txn, undefined),
                            catString: (0, searchFilter_1.getFieldString)('category', txn, undefined),
                            tagString: (0, searchFilter_1.getFieldString)('tags', txn, undefined),
                            txn,
                            count: 1,
                        };
                        const key = txn.payee ? (_b = txn.payee) === null || _b === void 0 ? void 0 : _b.toLowerCase() : '';
                        const prevPayee = payeeList.get(key);
                        if (prevPayee) {
                            if (luxon_1.DateTime.fromISO(((_c = prevPayee.txn) === null || _c === void 0 ? void 0 : _c.postedOn) || '') < luxon_1.DateTime.fromISO(txn.postedOn)) {
                                payeeList = payeeList.set(key, (0, types_1.mkPayee)(Object.assign(Object.assign({}, payeeObject), { count: payeeObject.count + 1 })));
                            }
                        }
                        else {
                            payeeList = payeeList.set(key, (0, types_1.mkPayee)(payeeObject));
                        }
                    }
                });
            }
            if (payeeList.size > 0) {
                payeeListById = payeeListById.set(accountId, payeeList);
            }
        }
    });
    return payeeListById;
}
exports.buildPayeeList = buildPayeeList;
function* createPayeeList() {
    // @ts-expect-error - Expected at least 2 arguments, but got 1.ts(2555)
    const transactionsByAccountId = yield (0, effects_1.select)(selectors_1.getTransactionsByAccountId);
    const accountsById = yield (0, effects_1.select)(accounts_1.accountsSelectors.getAccountsById);
    const payeeListById = buildPayeeList(accountsById, transactionsByAccountId, null);
    yield (0, effects_1.put)(actions.updatePayeeListSuccess(payeeListById));
}
exports.createPayeeList = createPayeeList;
function* updatePayeeList(data) {
    if (data && data.payload && data.payload.resources) {
        // @ts-expect-error - Expected at least 2 arguments, but got 1.ts(2555)
        const transactionsByAccountId = yield (0, effects_1.select)(selectors_1.getTransactionsByAccountId);
        const accountsById = yield (0, effects_1.select)(accounts_1.accountsSelectors.getAccountsById);
        const payeeListById = buildPayeeList(accountsById, transactionsByAccountId, data.payload.resources);
        yield (0, effects_1.put)(actions.updatePayeeListSuccess(payeeListById));
    }
}
exports.updatePayeeList = updatePayeeList;
function* triggerPayeeListUpdate(data) {
    let payload = { resources: [data.payload] };
    // @ts-expect-error - Expected 1-2 arguments, but got 0.ts(2554)
    if (data.type === transactions_1.transactionsActions.getTransactionsSuccess().type) {
        payload = data.payload;
        // @ts-expect-error - Expected 1-2 arguments, but got 0.ts(2554)
    }
    else if (data.type === transactions_1.transactionsActions.batchTransactions().type) {
        payload = { resources: data.payload };
    }
    yield (0, effects_1.put)(actions.updatePayeeListAsync(payload));
}
exports.triggerPayeeListUpdate = triggerPayeeListUpdate;
function* updatePayeeListActionWatcher() {
    yield (0, effects_1.takeLatest)(actions.updatePayeeList, updatePayeeList);
}
exports.updatePayeeListActionWatcher = updatePayeeListActionWatcher;
function* createPayeeListActionWatcher() {
    yield (0, effects_1.takeLatest)(actions.createPayeeList, createPayeeList);
}
exports.createPayeeListActionWatcher = createPayeeListActionWatcher;
function* transactionChangeActionWatcher() {
    yield (0, effects_1.takeLatest)([
        transactions_1.transactionsActions.batchTransactions,
        transactions_1.transactionsActions.createTransaction,
        transactions_1.transactionsActions.updateTransaction,
        transactions_1.transactionsActions.deleteTransaction,
        transactions_1.transactionsActions.getTransactionsSuccess,
    ], triggerPayeeListUpdate);
}
exports.transactionChangeActionWatcher = transactionChangeActionWatcher;
function* updateMemorizedPayee(action) {
    const state = yield (0, effects_1.select)();
    const isEnabled = yield (0, effects_1.select)(selectors_2.isCreateMemorizedRulesEnabled);
    const isSharedUser = yield (0, effects_1.select)(accountGroupsSelectors_1.isEntityShareUser);
    if (isEnabled && !isSharedUser) {
        const transactions = Array.isArray(action.payload) ? action.payload : [action.payload];
        yield (0, effects_1.call)(utils_1.upsertMemorizedPayeeRule, transactions, state);
    }
}
// This action watcher creates and updates the memorized payee 
function* transactionAddAndUpdateActionWatcher() {
    yield (0, effects_1.takeLatest)([
        transactions_1.transactionsActions.batchTransactionsSuccess,
        transactions_1.transactionsActions.createTransactionSuccess,
        transactions_1.transactionsActions.updateTransactionSuccess,
    ], updateMemorizedPayee);
}
exports.transactionAddAndUpdateActionWatcher = transactionAddAndUpdateActionWatcher;
// ====================================================
// EXPORTS
exports.default = [
    updatePayeeListActionWatcher,
    transactionChangeActionWatcher,
    transactionAddAndUpdateActionWatcher,
];
